import { render } from "./ProjectsPage.vue?vue&type=template&id=f1ff58aa&scoped=true"
const script = {}

import "./ProjectsPage.vue?vue&type=style&index=0&id=f1ff58aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ff58aa"]])

export default __exports__